// api.js

import { useToast } from 'vue-toastification'; // استيراد useToast من vue-toastification

const toast = useToast(); // إنشاء كائن toast
export default {
    async addToCart(data) {
        try {
            const response = await axios.post(`cart_items`, data);

            // console.log(response.status);
            // console.log(response.data);
            // if (response.status === 422) {
            //     toast.error(response.data?.message, {timeout: 3000, icon: 'fa-solid fa-circle-exclamation'});
            // }

            // Return response data if needed
            return response.data;
        } catch (error) {
            toast.error('Failed to add to cart', { timeout: 3000, icon: 'fa-solid fa-circle-exclamation' });

            throw new Error('Failed to add to cart');
        }
    },
    async removeFromCart(cart) {
        try {
            const response = await axios.delete(`cart_items/${cart.id}`);

            // Return response data if needed
            return response.data;
        } catch (error) {
            throw new Error('Failed to remove from cart');
        }
    },
    async checkCoupon(couponCode) {
        try {
            const response = await axios.post('coupons/check', { coupon_code: couponCode });
            return response.data;
        } catch (error) {
            console.error("Error checking coupon:", error);
            return error.response.data;
        }
    }
};
